import styled from 'styled-components';

export const ErrorMessageContainer = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0.75rem;
  height: 100%;
  border: 1px solid #cdd4da;
  box-sizing: border-box;
  border-radius: 6px;
  color: #ca4139;
`;

export const ErrorCode = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.675rem;
  font-size: 0.75rem;

  :first-child {
    margin-right: 0.5rem;
  }
`;
